import React from "react";
import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";

const ColorButton = styled(Button)(() => ({
  color: "#39484E",
  width: 220,
  height: 65,
  fontWeight: 700,
  fontSize: "18px",
  textTransform: "capitalize",
  borderRadius: "30px",
  backgroundColor: "#F6F4F0",
  border: "2px solid #F6F4F0",
  "&:hover": {
    color: "#F6F4F0",
    backgroundColor: "#39484E",
    borderColor: "#39484E",
  },
}));

const GetInvolved = () => {
  return (
    <Box
      margin={{ xs: "25% 0%", sm: "5% 0% 5% 0%" }}
      bgcolor={"#AC7551"}
      borderRadius={"30px"}
    >
      <Box padding={{ xs: "10%", sm: "4%" }}>
        <Typography
          fontWeight={700}
          variant="h3"
          textAlign={"center"}
          color={"#fff"}
          paddingBottom={{ xs: "6%", sm: "2%" }}
        >
          Get Involved
        </Typography>
        <Typography
          fontWeight={500}
          variant="h6"
          textAlign={"center"}
          color={"#fff"}
          paddingBottom={{ xs: "8%", sm: "2%" }}
          padding={{ xs: "0% 0% 8% 0%", sm: "0% 4% 2% 4%" }}
        >
          Join us in redefining the philanthropic landscape for Sub-Saharan
          Africa. Partner with AIR Fund to empower African communities to drive
          resilience, innovation, and sustainable development.
        </Typography>
        <Box display={"flex"} justifyContent={"center"}>
          <ColorButton size={"large"} variant={"contained"} href="/contact-us">
            Join Us
          </ColorButton>
        </Box>
      </Box>
    </Box>
  );
};

export default GetInvolved;
